import React from 'react'
import { Button } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

import { ArrowForward, Mail } from '@mui/icons-material';
import DnaIcon from '../../icons/DnaIcon'
import LandingSnackbar from './Snackbar';
import DevLoginModal from '../DevLoginModal';

import './index.css';
import SessionConstants from '../../config/SessionConstants';
import TabLock from '../../utils/TabLock';
import TabConflict from '../TabConflict';

const useStyles = makeStyles({
    landingLogin: {
        fontSize: '1em',
        textDecoration: 'none',
        backgroundColor: 'var(--secondary-color)',
        color: 'black',
        padding: '0.7em 0.8em',
        textTransform: 'uppercase',
        borderRadius: '5px',
        '&:hover': { // WCAG AAA compliant contrast
            backgroundColor: 'var(--secondary-color)',
            filter: 'brightness(87%)'
        },
    },
});

export default function Landing(props) {
    const classes = useStyles();
    const [devLoginModalIsOpen, setDevLoginModalIsOpen] = React.useState(false);
    //  Set when the user tries to log in while another ED3N tab already owns the session.
    //  Blocking here stops a second tab from authenticating and racing the single-use SAMS
    //  refresh token; the conflict screen sends the user back to the live tab.
    const [tabConflict, setTabConflict] = React.useState(false);
    const closeDevLoginModal = () => setDevLoginModalIsOpen(false);

    const openDevLoginModal = () => {
        if (TabLock.anotherTabActive()) {
            setTabConflict(true);
            return;
        }
        setDevLoginModalIsOpen(true);
    };

    const samsLogin = () => {
        if (TabLock.anotherTabActive()) {
            setTabConflict(true);
            return;
        }
        sessionStorage.setItem(SessionConstants.DEVLOGIN, 'false');
        window.location.assign("/login");
    }

    if (tabConflict) {
        return <TabConflict />;
    }

    return (
        <>
        <div className='landingContainer'>
            <div className='landingHeader'>
                <header>
                    <h1><DnaIcon style={{ fontSize: '0.875em', marginBottom: '-2px' }} className="dnaIcon" />ED3N</h1>
                </header>
            </div>
            <section className='landingBody' role='main'>
                <div className='landingTitle'>
                    <h2>
                        Welcome to ED3N
                    </h2>
                </div>
                <div className='landingDescription'>
                    The ED3N platform, developed by the CDC, aims to promote state-of-the-art detection of disease risk in newborns through enhanced data-driven decision-making tools, correlations, and resources. 
                </div>
                <div className='loginMessage'>
                    <div className='loginInstruction'>
                        <span>Access to ED3N is controlled using SAMS. You must have access to SAMS before accessing ED3N. If you require access to ED3N, please contact</span><a className='landingEmailLink' role='link' aria-label='send email' href="mailto:cdced3nsupport@cdc.gov?Subject=ED3N%20Access"><Mail className='landingEmailIcon' style={{ verticalAlign: 'middle', fontSize: '1.3rem', marginTop: '-2px' }} />CDC ED3N support</a>.
                    </div>
                    <div className='linkWrapper'>
                        <Button
                            onClick={samsLogin}
                            className={classes.landingLogin}
                            aria-label="login using SAMS"
                            startIcon={<ArrowForward />}
                            variant="contained"
                            color="primary"
                        >
                            Login using SAMS
                        </Button>                    
                    </div>
                    {(__ENVIRONMENT__ == 'development' || __ENVIRONMENT__ == 'test' || __ENVIRONMENT__ == 'training') ?
                    <div className='linkWrapper'>
                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={openDevLoginModal}
                            aria-label="dev login"
                            startIcon={<ArrowForward />}
                        >
                            Dev Login
                        </Button>   
                    </div> : ''}
                </div>
                <div className="landingFooter">
                    <section>
                        <div className="landingFooterSection">
                            <div className="landingNotice">
                            WARNING: This warning banner provides privacy and security notices 
                            consistent with applicable federal laws, directives, and other 
                            federal guidance for accessing this Government system, which 
                            includes all devices/storage media attached to this system. This 
                            system is provided for Government-authorized use only. Unauthorized 
                            or improper use of this system is prohibited and may result in 
                            disciplinary action and/or civil and criminal penalties. At any 
                            time, and for any lawful Government purpose, the government may 
                            monitor, record, and audit your system usage and/or intercept, 
                            search and seize any communication or data transiting or stored on 
                            this system. Therefore, you have no reasonable expectation of 
                            privacy. Any communication or data transiting or stored on this 
                            system may be disclosed or used for any lawful Government purpose.
                            </div>
                        </div>
                    </section>
                </div>
            </section>
            {devLoginModalIsOpen && (
                <DevLoginModal 
                    closeModal={closeDevLoginModal}
                    isModalOpen={devLoginModalIsOpen} 
                />
            )}
        </div>
        <div className='bkgdLogo'>
            <DnaIcon width={500} height={500} />
        </div>
        <LandingSnackbar />
        </>
    );
}